import _classCallCheck from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/classCallCheck";
import _createClass from "/supplier360/client/node_modules/babel-preset-react-app/node_modules/@babel/runtime/helpers/esm/createClass";
import FileSaver from 'file-saver';
import Auth from './Auth';

function getHeaders() {
  var headers = {
    'Content-Type': 'application/x-www-form-urlencoded',
    'browser-id': '551a8593cede18b4199eec32'
  };

  if (Auth.getToken()) {
    headers.Authorization = Auth.getAuthorizationHeader();
  }

  return headers;
}

var DownloadService = /*#__PURE__*/function () {
  function DownloadService() {
    _classCallCheck(this, DownloadService);
  }

  _createClass(DownloadService, null, [{
    key: "downloadFile",
    value: function downloadFile(url, fileName, extension) {
      var contentType;
      return fetch(url, {
        headers: getHeaders()
      }).then(function (res) {
        contentType = res.headers.get('Content-Type');
        return res.blob();
      }).then(function (content) {
        // replace all occurrences of '.' to prevent invalid file format error
        var cleanFileName = fileName.replace(/\./g, '_'); // fix for mht files https://stackoverflow.com/questions/31250/content-type-for-mht-files

        if (extension === 'mht') {
          contentType = 'message/rfc822';
          cleanFileName += '.mht';
        } // fix for msg file type


        if (extension === 'msg') {
          contentType = 'application/vnd.ms-outlook';
          cleanFileName += '.msg';
        }

        var blob = new Blob([content], {
          type: contentType
        }); // add rar extension to fix downloading rar files

        if (contentType.indexOf('application/x-rar-compressed') !== -1) {
          cleanFileName += '.rar';
        } // add html extension to fix safari html files


        if (contentType.indexOf('text/html; charset=utf-8') !== -1) {
          cleanFileName += '.html';
        } // add xlsx extension to fix downloading spreadsheet files


        if (contentType.indexOf('application/vnd.openxmlformats-officedocument.spreadsheetml.sheet') !== -1) {
          cleanFileName += '.xlsx';
        }

        return FileSaver.saveAs(blob, cleanFileName);
      });
    }
  }]);

  return DownloadService;
}();

export default DownloadService;